export enum SortOrderStatus {
  DESC = 'desc',
  ASC = 'asc',
}
